import React from 'react';
import { useSelector } from 'react-redux';
//------------------------------------------------------------------
import './style.scss';

export const ReloadCarouselButton = ({ handleReload }) => {
  const { menu_carrusel_button_retry } = useSelector(
    state => state.translations,
  );
  return (
    <div className="reload-carousel">
      <button
        className="reload-carousel__button"
        type="button"
        onClick={() => handleReload()}
      >
        {menu_carrusel_button_retry}
      </button>
    </div>
  );
};
